<template>
  <b-button
    @click="showModal()"
    :loading="!isReady" :disabled="!isReady"
    icon-left="download"
    size="is-large"
    expanded
    style="border-radius: 0"
  >
    {{ $t('Download') }}
  </b-button>
</template>

<script>
 import DownloadModal from '@/components/BrowseDownloadModal.vue'

 import { mapState } from 'vuex'

 export default {
   computed: {
     ...mapState('detail', ['image']),
     ...mapState('detail/content', { content: 'id' }),
     isReady() {
       return this.image && this.image.id && this.content
     }
   },
   methods: {
     showModal() {
       this.$buefy.modal.open({
         parent: this,
         component: DownloadModal,
	 canCancel: true,
	 props: {
	   imageKey: this.image.id,
	   contentKey: this.content
	 }
       })
     }     
   }
 }
</script>
